<template>
  <div class="income">
    <div class="commission_box">
      <div class="commission_statistical">
        <router-link to="/tech_withdrawal_log" class="withdrawal_detail">提现明细</router-link>
        <div class="commission_oktotal">
          <p class="commission_okprice">{{ok_income?ok_income:0}}</p>
          <p class="commission_oklabel">可提现收入(元)</p>
          <a  class="withdrawal_btn" @click="tech_withdrawal()">提现</a>
        </div>

        <div class="commission_info flex_center">
          <div class="commission_totalprice">
            <p>累计收入(元)</p>
            <p>{{total_income}}</p>
          </div>
          <div class="commission_finishprice">
            <p>已提现收入(元)</p>
            <p>{{finish_income}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="income_box">
      <p class="income_label">收入明细</p>

      <ul class="income_list">
        <li class="flex" v-for="(item,index) in tech_income" :key="index">
          <div class>{{item.servicetitle}}<span v-if="item.remark" class="income_remark">({{item.remark}})</span></div>
          <div class>
            <p class="c_i_price">+{{item.income_price}}</p>
            <p class="c_i_time">{{item.create_time_str}}</p>
          </div>
        </li>
        
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "income",
  components: {},
  data() {
    return {
      tech_income:[],
      finish_income:0,
      total_income:0,
      ok_income:0,
      tech_withdrawal_condition:0,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get_tech_income();
    },
    get_tech_income(){
      this.axios({
        url: this.api.tech.get_tech_income,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.tech_income = res.tech_income;
          this.finish_income = res.finish_income;
          this.total_income = res.total_income;
          this.ok_income = res.ok_income;
          this.tech_withdrawal_condition = res.tech_withdrawal_condition;
        }
      });
    },
    tech_withdrawal(){
      
      if(this.ok_income==0){
         this.$toast({
              message:"无可提现金额",
              duration:1500,
          });
          return;
      }
      if(this.tech_withdrawal_condition>this.ok_income){
          this.$toast({
              message:"可提现收入满"+this.tech_withdrawal_condition+"才能提现",
              duration:1500,
          });
          return;
      } 
      this.$router.push({'path':"tech_withdrawal",query:{}});
    }
  }
};
</script>
<style scoped>
.income_remark{
      color: red;
    font-size: 0.6rem;
}
.income_label {
  font-size: 0.75rem;
  color: #464646;
  padding: 0.85rem 0.75rem 0.4rem;
}
.income_list {
  background-color: white;
  font-size: 0.8rem;
  color: #484747;
}
.income_list li {
  border-bottom: 1px solid #eee;
  padding: 0.45rem 0.75rem;
}
.c_i_time {
  font-size: 0.6rem;
  color: #838181;
}
.commission_statistical {
  background-color: #45b9bc;
  color: white;
}
.commission_oktotal {
  text-align: center;
  padding: 2.5rem 0 0.75rem 0;
}
.commission_okprice {
  font-size: 1.5rem;
  color: #ffffff;
  font-weight: bold;
}
.commission_oklabel {
  font-size: 0.6rem;
  color: #ffffff;
  margin-top: 0.1rem;
}
.commission_info {
  background-color: rgba(27, 27, 27, 0.2);
  text-align: center;
}
.commission_totalprice {
  border-right: 1px solid rgba(255, 255, 255, 0.5);
}
.commission_totalprice,
.commission_finishprice {
  width: 50%;
  color: #ffffff;
  font-size: 0.6rem;
  margin: 0.35rem 0;
}
.commission_totalprice p,
.commission_finishprice p {
  padding: 0.1rem 0;
}
.icon-tixianchongzhi {
  color: #e97620;
}
.recommend_nav span {
  font-size: 0.75rem;
  color: #464646;
}
.recommend_navli {
  border-bottom: 1px solid #eee;
}
.icon-qian {
  color: #f8bf00;
}
.icon-tianchongxing-1 {
  color: #ea6953;
}
.icon-dkw_zhangdan {
  color: #e97620;
}
.icon-iconfonterweima {
  color: rgb(69, 185, 188);
}
.commission_statistical {
  position: relative;
}
.withdrawal_detail {
  position: absolute;
  right: 0.75rem;
  top: 0.85rem;
  font-size: 0.6rem;
  color: #ffffff;
}
.withdrawal_btn {
  display: inline-block;
  border: 1px solid #ffffff;
  border-radius: 5px;
  padding: 0.15rem 1rem;
  font-size: 0.75rem;
  margin-top: 1rem;
}
.c_i_price {
  color: #45b9bc;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/tech_income.vue